import { ExcelStyle } from "ag-grid-enterprise";

// Helper: Excel OOXML expects ARGB hex (8 chars) for reliable font color in export
export const excelColor = (hex: string) =>
  // excelColor is called with "#"-prefixed hex from styles and CF export; non-"#" is defensive
  /* v8 ignore next */
  `FF${hex.startsWith("#") ? hex.slice(1).toUpperCase() : hex}`;

export const excelStyles = [
  {
    id: "customHeader",
    height: 40,
    alignment: {
      vertical: "Center"
    },
    font: {
      size: 16,
      bold: true
    }
  },
  {
    id: "header",
    alignment: {
      vertical: "Center"
    },
    font: {
      size: 13,
      bold: true,
      color: "#262626"
    },
    interior: {
      color: "#f0f0f0",
      pattern: "Solid"
    }
  },
  {
    id: "hyperlinks",
    alignment: {
      vertical: "Top"
    },
    font: {
      underline: "Single",
      color: "#4448c1"
    }
  },
  {
    id: "cell",
    alignment: {
      vertical: "Top"
    },
    font: {
      color: "#262626"
    }
  },
  {
    id: "excelWrapText",
    alignment: {
      vertical: "Top",
      wrapText: true
    }
  },
  // Risk styles defined after "cell" so their font colors take precedence when merged
  {
    id: "highRisk",
    alignment: {
      vertical: "Top"
    },
    font: {
      color: excelColor("#CF1322")
    }
  },
  {
    id: "mediumRisk",
    alignment: {
      vertical: "Top"
    },
    font: {
      color: excelColor("#D46B08")
    }
  },
  {
    id: "lowRisk",
    alignment: {
      vertical: "Top"
    },
    font: {
      color: excelColor("#0958D9")
    }
  }
] as ExcelStyle[];
